import { z } from 'zod';
import { ClubHostPublicSchema } from './club-hosts.js';
import { ClubStatusSchema } from './clubs.js';

export const MyClubsContinueItemSchema = z.object({
  clubId: z.string(),
  paywallSlug: z.string().nullable(),
  clubTitle: z.string(),
  clubCoverUrl: z.string().nullable(),
  chapterId: z.string(),
  chapterTitle: z.string(),
  chapterIndex: z.number(),
  lastPosition: z.number().nullable(),
  progressPercent: z.number(),
  updatedAt: z.string(),
});

export type MyClubsContinueItem = z.infer<typeof MyClubsContinueItemSchema>;

export const MyClubsItemSchema = z.object({
  clubId: z.string(),
  paywallSlug: z.string().nullable(),
  title: z.string(),
  status: ClubStatusSchema,
  bookAuthor: z.string().nullable(),
  host: ClubHostPublicSchema,
  secondHost: ClubHostPublicSchema.nullable(),
  author: z.string().nullable(),
  coverUrl: z.string().nullable(),
  totalChapters: z.number(),
  completedChapters: z.number(),
  progressPercent: z.number(),
  lastReadAt: z.string().nullable(),
});

export type MyClubsItem = z.infer<typeof MyClubsItemSchema>;

export const MyClubsResponseSchema = z.object({
  continueItem: MyClubsContinueItemSchema.nullable(),
  items: z.array(MyClubsItemSchema),
});

export type MyClubsResponse = z.infer<typeof MyClubsResponseSchema>;
